import routes from './routes';
import { SetRoutes } from 'components';

const VacancyCategoriesPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default VacancyCategoriesPages;
